import { render, staticRenderFns } from "./RptTrimestral.vue?vue&type=template&id=126c61c2&"
import script from "./RptTrimestral.vue?vue&type=script&lang=js&"
export * from "./RptTrimestral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports